export const dayPickerOptions = [
    {
        label: 'Any Day',
        value: ''
    },
    {
        label: 'Mon',
        value: 'mon'
    },
    {
        label: 'Tue',
        value: 'tue'
    },
    {
        label: 'Wed',
        value: 'wed'
    },
    {
        label: 'Thu',
        value: 'thu'
    },
    {
        label: 'Fri',
        value: 'fri'
    },
    {
        label: 'Sat',
        value: 'sat'
    },
    {
        label: 'Sun',
        value: 'sun'
    }
];
